import { Component } from '@angular/core';
import { Router } from '@angular/router';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.css'],
})
export class AppComponent {
    baseClass = 'nav-link font-weight-bold';
    baseClassSub = 'nav-link tab';

    lockSrc = '../assets/loginBlack.svg';
    router;

    constructor(private privateRouter: Router) {
        this.router = privateRouter;
    }

    getTabClass(target: string, isMain: boolean): string {
        const activeClass = this.router.url.includes(target) ? ' active' : '';

        if (isMain) {
            return this.baseClass + activeClass;
        } else {
            return this.baseClassSub + activeClass;
        }
    }

    navigateTo(url: string): void {
        window.location.assign(url);
    }

    scroll(section: string): void {
        window.onload = () => {
            const elmnt = document.getElementById(section);
            if (elmnt) {
                const y = elmnt.getBoundingClientRect().top - 12;
                window.scrollTo({ top: y });
            } else {
                const url =
                    window.location.protocol +
                    '//' +
                    window.location.hostname +
                    ':' +
                    window.location.port +
                    '/' +
                    'not_found';

                this.navigateTo(url);
            }
        };
    }
}



// WEBPACK FOOTER //
// /Users/masonpimentel/Repos/mason-blog/src/app/app.component.ts